import type { CostEstimate } from '@cartwheel/api/v1'
import { CustomMessageBlock } from './commercial-estimate-display'
import { PerSessionSummary } from './per-session-summary'

interface OtherEstimateDisplayProps {
  estimate: CostEstimate
}

export function OtherEstimateDisplay({ estimate }: OtherEstimateDisplayProps) {
  return (
    <>
      <div className="flex justify-center my-4">
        <PerSessionSummary label="Other" labelColor="sand" perSessionAmount="Variable amount" />
      </div>

      {estimate.custom_message && <CustomMessageBlock message={estimate.custom_message} />}
    </>
  )
}
